const featuredImages = [
  { id: 6, name: "NFT 6", imageName: "47" },
  { id: 4, name: "NFT 4", imageName: "10" },
  { id: 3, name: "NFT 3", imageName: "19" },
  { id: 2, name: "NFT 2", imageName: "27" },
  { id: 1, name: "NFT 1", imageName: "24" },
];

export default featuredImages;
